<template>
    <VueFinalModal class="vfm-modal"
      content-class="vfm-modal-content"
      content-transition="vfm-fade"
      overlay-transition="vfm-fade">
      <h1 class="text-xl">
        {{ title }}
      </h1>
      <slot />
    </VueFinalModal>
</template>

<script setup lang="ts">
    import { VueFinalModal } from 'vue-final-modal'
    defineProps<{
        title?: string
    }>()
</script>